<img af-brand-logo [data-code]="brandCode?.toUpperCase()" data-type="BRAND" width="80px" [alt]="brandName" />
